// extracted by mini-css-extract-plugin
export default {"mainContainer":"research_mainContainer__CJvFc"};